export default __webpack_public_path__ + "static/media/crossroads16.fc1b3c6e.webp";